import { parseOptionalNumericEnumFromApi } from '@/utils/core/data-transformation';

export { parseOptionalNumericEnumFromApi };

/**
 * Picks `configurations` from GET `company/config` response (common response shapes).
 */
export function pickCompanyConfigurationsFromResponse(response) {
  if (!response || typeof response !== 'object') return {};
  return response.configurations || response.data?.configurations || {};
}

function isValidNumericEnumValue(enumObject, numericValue) {
  if (numericValue === null || numericValue === undefined) return false;
  return Object.values(enumObject).some((v) => typeof v === 'number' && v === numericValue);
}

/** Field keys for local state / reducer under `companyGlobalSettings`. */
export const COMPANY_GLOBAL_SETTING_FIELDS = Object.freeze({
  mfaPolicy: 'mfaPolicy',
  evaluationMode: 'evaluationMode',
  defaultDecision: 'defaultDecision',
});

/**
 * Partial PATCH body for the changed field only (the branch that applies).
 * Sends the numeric enum value as held in Select state (not EnumMember strings).
 * @param {'mfaPolicy'|'evaluationMode'|'defaultDecision'} field
 * @param {number} numericValue
 */
export function buildCompanyConfigPatchPayload(field, numericValue, enums) {
  const {
    MfaRequirementPolicy,
    CompanyAccessPolicyEvaluationMode,
    CompanyAccessPolicyDefaultDecision,
  } = enums;
  let enumObject;
  if (field === COMPANY_GLOBAL_SETTING_FIELDS.mfaPolicy) enumObject = MfaRequirementPolicy;
  else if (field === COMPANY_GLOBAL_SETTING_FIELDS.evaluationMode)
    enumObject = CompanyAccessPolicyEvaluationMode;
  else if (field === COMPANY_GLOBAL_SETTING_FIELDS.defaultDecision)
    enumObject = CompanyAccessPolicyDefaultDecision;
  else return {};

  if (!isValidNumericEnumValue(enumObject, numericValue)) return {};

  if (field === COMPANY_GLOBAL_SETTING_FIELDS.mfaPolicy) {
    return { mfaPolicy: numericValue };
  }
  if (field === COMPANY_GLOBAL_SETTING_FIELDS.evaluationMode) {
    return { accessPolicy: { evaluationMode: numericValue } };
  }
  return { accessPolicy: { defaultDecision: numericValue } };
}
